<template>
	<CbsContextMenu v-bind="$attrs" :class="['device-context-menu', { 'mr-5': displayMode === 'detail' }]" :menuListDataBinding="{ class: 'device-context-menu-list' }">
		<div class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickEdit', target)">
			<i class="nucleo mr-3 text-primary nucleo-edit" />
			{{ $t("Edit") }}
		</div>

		<div class="device-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickDelete', target)">
			<i class="nucleo mr-3 text-primary nucleo-trash-can" />
			{{ $t("Delete") }}
		</div>
	</CbsContextMenu>
</template>

<script>
import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	name: "BasicContextMenu",
	mixins: [],
	components: { CbsContextMenu },
	props: {
		target: {
			type: Object,
			required: true
		},
		displayMode: {
			type: String,
			default: "list",
			validator: prop => ["list", "detail"].includes(prop)
		}
	},
	emits: {
		onClickEdit: {},
		onClickDelete: {}
	}
};
</script>

<style lang="scss" scoped>
.device-context-menu {
	&.cbs-context-menu--horizontal ::v-deep .cbs-context-menu__btn-trigger {
		color: var(--color-gray-4);
	}
}

.device-context-menu-list {
	.device-context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}
</style>
